module.exports = __webpack_public_path__ + "static/media/ad.caaa807a.svg";